import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const postDemoBooking = (payload) => api.post("/demo-booking", payload).then((r) => r.data);
export const postEventRegistration = (payload) => api.post("/event-registration", payload).then((r) => r.data);
export const postPartnerApplication = (payload) => api.post("/partner-application", payload).then((r) => r.data);
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// Admin
export const adminHeaders = (key) => ({ headers: { "X-Admin-Key": key } });
export const adminVerify = (key) => api.post("/admin/verify", {}, adminHeaders(key)).then((r) => r.data);
export const adminStats = (key) => api.get("/admin/stats", adminHeaders(key)).then((r) => r.data);
export const adminListDemos = (key) => api.get("/admin/demo-bookings", adminHeaders(key)).then((r) => r.data);
export const adminListEvents = (key) => api.get("/admin/event-registrations", adminHeaders(key)).then((r) => r.data);
export const adminListPartners = (key) => api.get("/admin/partner-applications", adminHeaders(key)).then((r) => r.data);
export const adminListContacts = (key) => api.get("/admin/contact-messages", adminHeaders(key)).then((r) => r.data);
